import type { ReactNode } from 'react';
import { t } from '../i18n/lingua.js';

/**
 * Una coppia etichetta/valore dentro una scheda in sola lettura.
 *
 * Il trattino lo mette il componente, non chi lo usa: un campo vuoto deve
 * dire «qui non c'è niente», non lasciare uno spazio bianco che si confonde
 * con un errore di caricamento.
 */
export function Dato({
  etichetta,
  children,
  pieno,
  mono,
  nota,
}: {
  etichetta: string;
  children?: ReactNode;
  pieno?: boolean;
  /** Codici e numeri: incolonnati si confrontano a colpo d'occhio. */
  mono?: boolean;
  /** Riga piccola sotto l'etichetta, per spiegare un campo che non è ovvio. */
  nota?: string;
}) {
  const vuoto = children === null || children === undefined || children === '';
  return (
    <div className={pieno ? 'field span-2' : 'field'}>
      <label>
        {t(etichetta)}
        {nota && <span className="dim" style={{ fontWeight: 400 }}>{nota}</span>}
      </label>
      <div className={mono && !vuoto ? 'readonly num' : 'readonly'}>
        {vuoto ? <span className="dim">—</span> : children}
      </div>
    </div>
  );
}
